module.exports = __webpack_public_path__ + "static/media/line.f08ca7f9.svg";